module.exports = __webpack_public_path__ + "static/media/c41.4bb6847c.png";